import { useSelector } from 'react-redux'
import { StateExtended } from '../../_config/interfaces'

export function useInsightFilterReportSelector() {
    const filterData = useSelector((state: StateExtended) => state.insightFilterReport)
    return filterData
}
